import { Pipe, PipeTransform } from '@angular/core';
import { MenuGroupData } from '../menu-group/menu-group.component';
import { UserCategory } from '../../../../../map/user-guide/user-guide.service';
import { PRESET_FEATURES } from './menu-preset.config';

@Pipe({ name: 'filterByPreset', pure: true })
export class FilterByPresetPipe implements PipeTransform {
  transform(groups: MenuGroupData[], preset: UserCategory | null): MenuGroupData[] {
    const allowed = preset ? PRESET_FEATURES[preset] : null;
    if (!allowed) return groups;

    return groups.reduce<MenuGroupData[]>((acc, group) => {
      const mapColor = group.data.mapColor?.filter((f) => allowed.has(f.featureConst)) ?? null;

      if (mapColor?.length) {
        // Group is relevant — show all its charts and places unchanged so Charts/Places
        // tabs are never left with an empty section.
        acc.push({ ...group, data: { mapColor, charts: group.data.charts, places: group.data.places } });
        return acc;
      }

      // No map features matched (e.g. POI group): filter charts/places individually.
      const charts = group.data.charts?.filter((f) => allowed.has(f.featureConst)) ?? null;
      const places = group.data.places?.filter((f) => allowed.has(f.featureConst)) ?? null;
      if (charts?.length || places?.length) {
        acc.push({ ...group, data: { mapColor, charts, places } });
      }
      return acc;
    }, []);
  }
}
